/* eslint-disable no-undef */
import SelectCore from './SelectCore';
import { getRemoteDefaultValues } from './utils/remoteDefaultValues';

class SelectCompanies extends SelectCore {
  componentDidMount() {
    const { defaultValue, onChange } = this.props;

    window
      .select2_companies($(this.select), {
        placeholder: this.defaultPlaceholder(),
      })
      .on('change', onChange);

    if (defaultValue) {
      getRemoteDefaultValues({
        searchUrl: Routes.search_companies_path({ ids: defaultValue }),
        selectElement: $(this.select),
      });
    }
  }

  componentDidUpdate() {
    window.select2_companies($(this.select), {
      placeholder: this.defaultPlaceholder(),
    });
  }

  defaultPlaceholder = () => {
    const { placeholder } = this.props;

    return placeholder || I18n.t('web.users.search.companies');
  };
}

export default SelectCompanies;
